<template>
  <div style="margin: 25px">
    <vue-good-table
      :columns="hareketListcolumns"
      :rows="hareketList"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
      </template>

      <!-- pagination -->
    </vue-good-table>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      dir: false,

      hareketListcolumns: [
        {
          label: "Hareket Tipi",
          field: "TRANSTYPENAME",
        },
        {
          label: "Giriş",
          field: "GIRIS",
        },
        {
          label: "Çıkış",
          field: "CIKIS",
        },
      ],
      hareketList: [],
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    hareketTuru() {
      var vm = this;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockEktsre_HareketTuru(args, function (err, result) {
          if (result.INT_Ls_StockEktsre_HareketTuruResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_StockEktsre_HareketTuruResult);
          vm.hareketList = vm.veriler;
          vm.$store.commit("account/EXCEL_YADIRILACAK_DATA", vm.hareketList);

          // vm.rowData = vm.veriler;
        });
      });
    },
  },
  created() {
    this.hareketTuru();
  },
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>